import { Location, LocationStrategy, PathLocationStrategy, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { COMMON_IMPORTS } from 'app/common-imports';
import { NavbarComponent } from './components/navbar/navbar.component';

@NgModule({
    imports: [COMMON_IMPORTS, MatIconModule, MatMenuModule, MatToolbarModule, CommonModule, RouterModule],
    exports: [NavbarComponent],
    declarations: [NavbarComponent],
    providers: [
        Location,
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ],
})
export class NavModule { }
